import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import type { IconName } from '@/components/common/Icon';

export interface PractitionerNavigationItem {
  id: string;
  labelKey: string;
  iconName: IconName;
  route: string | null;
  ownerOnly: boolean;
  comingSoon: boolean;
  requiredModule?: string;
  unreadBadge?: boolean;
}

export const PRACTITIONER_NAVIGATION_ITEMS: PractitionerNavigationItem[] = [
  {
    id: 'dashboard',
    labelKey: 'nav.dashboard',
    iconName: 'LayoutDashboard',
    route: APPLICATION_ROUTES.workspaceDashboard,
    ownerOnly: false,
    comingSoon: false,
  },
  {
    id: 'clients',
    labelKey: 'nav.clients',
    iconName: 'Users',
    route: APPLICATION_ROUTES.workspaceClients,
    ownerOnly: false,
    comingSoon: false,
  },
  {
    id: 'patients',
    labelKey: 'nav.patients',
    iconName: 'PawPrint',
    route: APPLICATION_ROUTES.workspacePatients,
    ownerOnly: false,
    comingSoon: false,
  },
  {
    id: 'intake',
    labelKey: 'nav.intake',
    iconName: 'ClipboardList',
    route: APPLICATION_ROUTES.workspaceIntake,
    ownerOnly: false,
    comingSoon: false,
    requiredModule: 'first_consultation',
    unreadBadge: true,
  },
  {
    id: 'consents',
    labelKey: 'nav.consents',
    iconName: 'ShieldCheck',
    route: APPLICATION_ROUTES.workspaceConsents,
    ownerOnly: false,
    comingSoon: false,
    requiredModule: 'consents',
  },
  {
    id: 'organization',
    labelKey: 'nav.organization',
    iconName: 'Building',
    route: APPLICATION_ROUTES.workspaceOrganization,
    ownerOnly: true,
    comingSoon: false,
  },
  {
    id: 'reports',
    labelKey: 'nav.reports',
    iconName: 'BarChart',
    route: APPLICATION_ROUTES.workspaceReports,
    ownerOnly: true,
    comingSoon: false,
    requiredModule: 'reports',
  },
  {
    id: 'notifications',
    labelKey: 'nav.notifications',
    iconName: 'Bell',
    route: APPLICATION_ROUTES.workspaceNotifications,
    ownerOnly: false,
    comingSoon: false,
  },
  {
    id: 'chat',
    labelKey: 'nav.chat',
    iconName: 'MessageCircle',
    route: APPLICATION_ROUTES.workspaceChat,
    ownerOnly: false,
    comingSoon: false,
    requiredModule: 'chat',
    unreadBadge: true,
  },
  {
    id: 'broadcasts',
    labelKey: 'nav.broadcasts',
    iconName: 'Megaphone',
    route: APPLICATION_ROUTES.workspaceBroadcasts,
    ownerOnly: true,
    comingSoon: false,
    requiredModule: 'broadcasts',
  },
  {
    id: 'support',
    labelKey: 'nav.support',
    iconName: 'Ticket',
    route: APPLICATION_ROUTES.workspaceSupport,
    ownerOnly: false,
    comingSoon: false,
    unreadBadge: true,
  },
  {
    id: 'settings',
    labelKey: 'nav.settings',
    iconName: 'Settings',
    route: APPLICATION_ROUTES.workspaceSettings,
    ownerOnly: false,
    comingSoon: false,
  },
];

export function selectVisibleNavigationItems(
  enabledModules: string[],
  isOwner: boolean
): PractitionerNavigationItem[] {
  return PRACTITIONER_NAVIGATION_ITEMS.filter(function isVisible(item) {
    if (
      item.requiredModule !== undefined &&
      enabledModules.includes(item.requiredModule) === false
    ) {
      return false;
    }
    if (item.ownerOnly === true) {
      return isOwner;
    }
    return true;
  });
}
